var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sound-root"},[_c('SinglePlayer',{attrs:{"soundUrl":_vm.currentItem.tts_url}}),_vm._l((_vm.pinyinList),function(item,index){return _c('div',{key:item.id,staticClass:"pinyin-item",class:_vm.getPinyinBc(index)},[_vm._v(" "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }